module.exports = "//img1.rrcimg.com/_next/static/src/assets/fs_UXb4D.png";